import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router";
import { useWorkspaceContext } from "@core/context";
import { getApprovalAnnotations } from "@modules/docs/annotations/services";

export function useGetApprovalAnnotations() {
  const { workspaceId } = useWorkspaceContext();
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams] = useSearchParams();
  const approvalId = searchParams.get("approval_id") ?? "";

  return useQuery({
    queryKey: ["approval-annotations", workspaceId, projectId, approvalId],
    queryFn: () => getApprovalAnnotations(workspaceId, projectId!, approvalId),
    enabled: !!workspaceId && !!projectId && !!approvalId,
  });
}
